export const getStates = (menu = "tag-navigator", other) => {
  const base = menu || "tag-navigator";
  return {
    [base]: {
      nav: 1978,
      landing: true,
      menu, // <ui-view/>
      breadcrumbs: true,
      pageHeader: true,
      icon: "tags",
      title: "Tag Navigator Demo",
      url: "/" + base, // + "?uploaded&mode",
      params: {},
      // rerouteTo: `${base}.list`,
      // authorize: s => s.hasPermission("ViewCatalogs"),
      templateProvider: $stateParams => `<tag-navigator-demo  />`,
      ...other
    }
  };
};

export default getStates();
